import { Stack } from '@mui/material'
import type { FC } from 'react'

import { ButtonsContainer } from '@/components/IdentityCard/IdentityCard'
import ReferenceOutcomeStatusPill from '@/components/ReferenceOutcomeStatusPill'
import type { Income } from '@/types/Activity'
import type { OutcomeStatus } from '@/types/Outcome'
import { isFinalOutcome } from '@/utils/outcome'
import { hasExpired, hasCompletedBotJourney } from '@/utils/referee'

import AddEmployerReferee from './Add'
import EmployerReferenceDetails from './EmployerReferenceDetails'
import RemoveEmployerReference from './Remove'
import Title from './Title'

interface Props {
  income: Income
  customerId: string
  subjectId: string
  navigateToEmployerReferee: (id: string) => void
  incomeOutcomeStatus?: OutcomeStatus
  applicantName?: string
  isRestrictedReference?: boolean
}

const EmployerReference: FC<Props> = ({
  income,
  customerId,
  subjectId,
  navigateToEmployerReferee,
  incomeOutcomeStatus,
  applicantName,
  isRestrictedReference,
}) => {
  const employerReference = income.employerReference

  return (
    <div>
      {employerReference ? (
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between">
            <Title />
            {!isRestrictedReference && !isFinalOutcome(incomeOutcomeStatus) && (
              <ButtonsContainer>
                <RemoveEmployerReference
                  customerId={customerId}
                  subjectId={subjectId}
                  refereeId={employerReference.subjectId}
                />
              </ButtonsContainer>
            )}
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="space-between"
          >
            {hasExpired(employerReference) ? (
              <p>An employer reference has expired for this application.</p>
            ) : hasCompletedBotJourney(employerReference) ? (
              <p>
                An employer reference has been filled out to vouch for this application.
              </p>
            ) : (
              <p>Waiting for employer to submit their information.</p>
            )}
            <ReferenceOutcomeStatusPill
              referenceOutcomeStatus={employerReference.outcome.status}
            />
          </Stack>

          <EmployerReferenceDetails
            applicantName={applicantName}
            employerReference={employerReference}
            navigateToEmployerReferee={navigateToEmployerReferee}
          />

          <hr />
        </Stack>
      ) : (
        <>
          <Title />
          <p>This income does not have an employer reference.</p>
          {!isRestrictedReference && (
            <AddEmployerReferee
              customerId={customerId}
              subjectId={subjectId}
              incomeId={income.id}
            />
          )}
        </>
      )}
    </div>
  )
}

export default EmployerReference
